import { create } from 'zustand';

interface EpisodeSelectionState {
  selectedIds: Set<string>;
  toggle: (id: string) => void;
  selectAll: (ids: string[]) => void;
  clearSelection: () => void;
  isSelected: (id: string) => boolean;
}

export const useEpisodeSelectionStore = create<EpisodeSelectionState>((set, get) => ({
  selectedIds: new Set(),

  toggle: (id) =>
    set((state) => {
      const next = new Set(state.selectedIds);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return { selectedIds: next };
    }),

  selectAll: (ids) =>
    set(() => ({ selectedIds: new Set(ids) })),

  clearSelection: () =>
    set(() => ({ selectedIds: new Set() })),

  isSelected: (id) => get().selectedIds.has(id),
}));
